module.exports = __webpack_public_path__ + "static/media/w-2_20.60b0a671.png";